import cx from 'classnames';
import * as React from 'react';

import './styles/BoxFooter.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
  size?: 'medium' | 'small';
  dark?: boolean;
  hideBorder?: boolean;
};

/**
 * ## Footer area for use within a [Box](/internal/components/Box).
 *
 * # Common Usage
 * ```example
 * <Box>
 *   <BoxHeader
 *     subtext="BoxHeader subtext"
 *     title="BoxHeader title"
 *   />
 *   <BoxBody>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </BoxBody>
 *   <BoxFooter>
 *     <Button>Button</Button>
 *   </BoxFooter>
 * </Box>
 * ```
 */

class BoxFooter extends React.Component<Props> {
  render() {
    const { children, className, size, dark, hideBorder } = this.props;

    return (
      <footer
        className={cx(
          'BoxFooter',
          size && `BoxFooter--${size}`,
          dark && `BoxFooter--dark`,
          hideBorder && 'BoxFooter--hideBorder',
          className
        )}
      >
        {children}
      </footer>
    );
  }
}

export default BoxFooter;
